import { BasePairName } from '@ui/assets/config/trade-pair-listings';
import { ZERO_BIG_NUMBER } from '@ui/lib/bignumber';
import { TradePair } from '@ui/types/tradePair';
import BigNumber from 'bignumber.js';

export const getTradePairsVolume = (
  tradePairs: TradePair[] | readonly TradePair[],
): Map<BasePairName, BigNumber> => {
  const pairToVolume = new Map<BasePairName, BigNumber>();

  tradePairs.forEach((tradePair) => {
    pairToVolume.set(
      tradePair.baseName,
      tradePair.volumeUSDSnapshot.plus(
        pairToVolume.get(tradePair.baseName) ?? ZERO_BIG_NUMBER,
      ),
    );
  });

  return pairToVolume;
};
